/**
 * Máscaras de digitação. Cada uma recebe o texto como está no campo (digitado,
 * colado ou já mascarado) e devolve a forma exibida; aplicar duas vezes não muda
 * nada. `literal` diz quais caracteres a máscara insere sozinha, para o cursor
 * ficar no lugar certo (ver `mascarar` em @vetbolso/ui).
 */
export type Mascara = { formatar: (v: string) => string; literal?: RegExp };

const digitos = (v: string, max: number) => v.replace(/\D/g, "").slice(0, max);

/** 000.000.000-00, montado à medida que se digita. */
export const MASCARA_CPF: Mascara = {
  formatar: (v) =>
    digitos(v, 11)
      .replace(/^(\d{3})(\d)/, "$1.$2")
      .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1-$2"),
  literal: /[.-]/,
};

/** Código de entrada por e-mail: 6 dígitos. */
export const MASCARA_CODIGO: Mascara = { formatar: (v) => digitos(v, 6) };

/** Número decimal em pt-BR: dígitos e uma vírgula; ponto digitado vira vírgula. */
export const MASCARA_DECIMAL: Mascara = {
  formatar: (v) => {
    const s = v.replace(/\./g, ",").replace(/[^\d,]/g, "");
    const i = s.indexOf(",");
    const n = i < 0 ? s : `${s.slice(0, i)},${s.slice(i + 1).replace(/,/g, "")}`;
    return (n.startsWith(",") ? `0${n}` : n).slice(0, 12);
  },
};

/** Número de inscrição no CRMV: até 6 dígitos. */
export const MASCARA_CRMV: Mascara = { formatar: (v) => digitos(v, 6) };

/** Sigla de UF: duas letras maiúsculas. */
export const MASCARA_UF: Mascara = {
  formatar: (v) =>
    v
      .replace(/[^A-Za-z]/g, "")
      .slice(0, 2)
      .toUpperCase(),
};
